import request from '@/utils/request'

/**
 * 查询推荐商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProductLabel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProductLabel',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询可选商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存商品标签
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveProductLabel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.saveProductLabel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除商品标签
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteProductLabel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.deleteProductLabel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}